module.exports = __webpack_public_path__ + "img/person_7.de4b5476.jpg";